import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import DoctorList from "../../../../components/Shared/DoctorList/doctor-list";

import "./onCallSearchResult.scss";

import {
  doctorListInputData,
  doctorListParams,
} from "../../../../components/Shared/DoctorList/doctor-list.model";
import { CONSTANTS } from "../../../../constants";
import { SearchResultDataModel } from "../../OnCallLookUpModel";
import { utilService } from "../../../../services";
import { IonButton, IonIcon } from "@ionic/react";
import { statusBoardService } from "../../../StatusBoard/StatusBoard.service";
import { OnCallLookUpInputService } from "../../OnCalllookUpService";
import { AddProviderContext } from "../../../StatusBoard/components/StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProvider";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import classNames from "classnames/bind";
import { statusBoardSocketService } from "../../../StatusBoard/StatusBoardSocketService";
import { useToast } from "@agney/ir-toast";
import { SupportStaffProviderContext } from "../../../StatusBoard/components/SupportStaff/SupportStaff";
import _ from "lodash";
import { onCallSearchResultService } from "./OnCallSearchResult.service";
import { dataTransferService } from "../../../../services/dataTransferService";
import { chevronBackOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";
interface OnCallSearchResultProps {
  userSelectedData: SearchResultDataModel;
  backBtnClicked: (data: boolean) => void;
  updateAPICall?: any;
  dataFromComponent: string;
  pId?: any;
  isFromCaseHistory?: any;
  providerList?:any;
}

const OnCallSearchResult: React.FC<OnCallSearchResultProps> = (props) => {
    const { t } = useTranslation("onCallLookup");
  
  const AddProviderContextData = useContext(
    statusBoardService.selectedProviderPoupType
      ? SupportStaffProviderContext
      : AddProviderContext
  );
  const [params, setParams] = useState<any>(Object);
  const [screenType, setScreenType] = useState<string>("");
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [selectedDoctorDetails, setSelectedDoctorDetails]: any = useState([]);
  const [isShowResult, setisShowResult] = useState<boolean>(true);
  const [isLargeScreen, setIsLargeScreen]: any = useState(true);
  const [activeResultTab, setActiveResultTab] = useState<string>("oncall");
  const Toast = useToast();

  useEffect(() => {
    setSelectedDoctorDetails([]);
    checkParamsAndMapData();
  }, [props.userSelectedData]);

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    getScreenTypeString();
    checkIfLargeScreen();
  }, []);

  useLayoutEffect(() => {
    let sub = dataTransferService.getOnCallResultAction.subscribe(
      (data: any) => {
        if (data === true) {
          setisShowResult(true);
        } else {
          setisShowResult(false);
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  const checkParamsAndMapData = () => {
    if (props.userSelectedData.selectedUserid) {
      const resData = mapParamsData();
      setParams(resData);
    }
  };

  const mapParamsData = () => {
    const paramsObj: doctorListParams = {
      group_id:
        props.userSelectedData.OptionSelected === "group"
          ? props.userSelectedData.selectedUserid
          : "",
      search_date: getDate(),
      hospital_id: props.userSelectedData.SiteSelected!.toString(),
      guid:
        props.userSelectedData.OptionSelected === "individual_provider"
          ? props.userSelectedData.selectedUserid
          : "",
      speciality:
        props.userSelectedData.OptionSelected === "speciality"
          ? props.userSelectedData.selectedUserid
          : "",
      hours: utilService.getCurrentHour().toString(),
      minutes: utilService.getCurrentMinutes().toString(),
      date: utilService.getCurrentDate(),
      reg_code: utilService.getNetwork(),
    };
    onCallSearchResultService.setonCallSearchResultDataFromComponent(paramsObj);
    onCallSearchResultService.setonCallSiteIdFromComponent(
      props.userSelectedData.SiteSelected
    );
    return paramsObj;
  };

  const getScreenTypeString = () => {
    setScreenType(utilService.getScreenSize());
  };

  const getDate = () => {
    const updateDateTime =
      props.userSelectedData.DateSelected +
      " " +
      props.userSelectedData.TimeSelected;
    const resultDate = utilService.getDateFormat(updateDateTime);
    return resultDate;
  };

  const doctorListInput: doctorListInputData = {
    componentName: CONSTANTS.COMPONENTS.ONCALL_LOOK_UP,
    isMultiSelectEnabled: false,
    isShowColorBadge: false,
  };

  const getSelectedCard = (selectedCard: any) => {
    setSelectedDoctorDetails(selectedCard);
  };

  const addProviderDetails = () => {
    if(!(props?.providerList?.some((provider:any)=>provider?.guid===selectedDoctorDetails[0].guid)&&props?.isFromCaseHistory)){
      if (
        AddProviderContextData.popUptype ===
          CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER &&
        _.values(AddProviderContextData.SelectedSupportStaffDetails).every(
          _.isEmpty
        )
      ) {
        props.isFromCaseHistory
          ? updateProviderInCaseHistory()
          : updateProvider();
      } else if (
        AddProviderContextData.popUptype ===
        CONSTANTS.PROVIDER_POPUPTYPE.PRIMARY_MD
      ) {
        updatePrimaryMD();
      } else if (
        !utilService.isEmpty(AddProviderContextData.SelectedSupportStaffDetails)
      ) {
        updateCommonPoviderDetails();
      }
      if (!props.isFromCaseHistory) {
        const socketParams = {
          type: "providers",
        };
        statusBoardSocketService.sendSbInputSocketParams(socketParams);
      }
    }else{
      Toast?.error("The selected provider has already been added")
    }
  };

  const updateProviderInCaseHistory = async () => {
    let apiParams = getProviderParams();
    setLoaderStatus(true);
    const respProviderList: any =
      await OnCallLookUpInputService.setCaseHistoryProviderList(apiParams);
    if (respProviderList.isSuccess) {
      props.updateAPICall(props.pId);
      Toast.success(t("providerAddedSuccess"));
    } else {
      Toast.error(respProviderList.message);
    }
    setLoaderStatus(false);
  };

  const updateProvider = async () => {
    if (selectedDoctorDetails[0].onGoing) {
      let apiParams = getProviderDetailsParams();
      setLoaderStatus(true);
      const respProviderList: any =
        await OnCallLookUpInputService.setProviderList(apiParams);
      if (respProviderList.isSuccess) {
        AddProviderContextData.updateProviderList(respProviderList.result);
        Toast.success(t("providerAddedSuccess"));
      } else {
        Toast.error(respProviderList.message);
      }
      setLoaderStatus(false);
    } else {
      Toast.error(t("notOnCallError"));
    }
  };

  const updatePrimaryMD = async () => {
    let apiParams = getPrimaryMDParams();
    setLoaderStatus(true);
    const respProviderList: any =
      await OnCallLookUpInputService.setPrimaryMDList(apiParams);
    if (respProviderList.isSuccess) {
      Toast.success("Primary MD added successfully");
      props.updateAPICall(props.pId);
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.PRIMARY_MD,
        bedId:
          statusBoardService.rowData && statusBoardService.rowData.id
            ? statusBoardService.rowData.id
            : "",
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      if (!props.isFromCaseHistory) {
        statusBoardSocketService.sendSbSocketParams(socketParams);
      }
      AddProviderContextData.updateProviderList([]);
    } else {
      Toast.error(respProviderList.message);
    }
    setLoaderStatus(false);
  };

  const getProviderParams = () => {
    const apiParams = {
      patient_id: props.pId,
      hour: utilService.getCurrentHour(),
      minute: utilService.getCurrentMinutes(),
      date: utilService.getCurrentDate(),
      reg_code: utilService.getNetwork(),
      guid:
        selectedDoctorDetails[0].guid && selectedDoctorDetails[0].guid
          ? [selectedDoctorDetails[0].guid]
          : "",
      user_guid: utilService.getLoggedUserGuid(),
    };
    return apiParams;
  };

  const getProviderDetailsParams = () => {
    const apiParams = {
      bedId:
        statusBoardService.rowData && statusBoardService.rowData.id
          ? statusBoardService.rowData.id
          : "",
      hour: utilService.getCurrentHour(),
      minute: utilService.getCurrentMinutes(),
      date: utilService.getCurrentDate(),
      reg_code: utilService.getNetwork(),
      guid:
        selectedDoctorDetails[0].guid && selectedDoctorDetails[0].guid
          ? selectedDoctorDetails[0].guid
          : "",
      scheduleNameId: selectedDoctorDetails[0].shiftTime[0].scheduleNameId
        ? selectedDoctorDetails[0].shiftTime[0].scheduleNameId
        : "",
    };
    return apiParams;
  };

  const getPrimaryMDParams = () => {
    const apiParams = {
      reg_code: utilService.getNetwork(),
      guid:
        selectedDoctorDetails[0].guid && selectedDoctorDetails[0].guid
          ? selectedDoctorDetails[0].guid
          : "",
      pid:
        statusBoardService.rowData && statusBoardService.rowData.pid
          ? statusBoardService.rowData.pid
          : props.pId,
    };

    return apiParams;
  };

  const getCommonPoviderDetails = () => {
    if (
      !utilService.isEmpty(AddProviderContextData.SelectedSupportStaffDetails)
    ) {
      const apiParams = {
        reg_code: utilService.getNetwork(),
        guid: AddProviderContextData.SelectedSupportStaffDetails["guid"]
          ? AddProviderContextData.SelectedSupportStaffDetails["guid"]
          : "",
        id: AddProviderContextData.SelectedSupportStaffDetails["id"]
          ? AddProviderContextData.SelectedSupportStaffDetails["id"]
          : null,
        name: AddProviderContextData.SelectedSupportStaffDetails["name"]
          ? AddProviderContextData.SelectedSupportStaffDetails["name"]
          : "",
        common_provider:
          selectedDoctorDetails[0].guid && selectedDoctorDetails[0].guid
            ? selectedDoctorDetails[0].guid
            : "",
        site: AddProviderContextData.SelectedSupportStaffDetails["site"]
          ? AddProviderContextData.SelectedSupportStaffDetails["site"]
          : null,
        specialisation: AddProviderContextData.SelectedSupportStaffDetails[
          "specialisation"
        ]
          ? AddProviderContextData.SelectedSupportStaffDetails["specialisation"]
          : "",
      };

      return apiParams;
    }
  };

  const updateCommonPoviderDetails = async () => {
    var currentProvider: any =
      AddProviderContextData.SelectedSupportStaffDetails.common_provider;

    if (selectedDoctorDetails[0].onGoing) {
      //if no providers is added yet and the card is empty
      if (_.isEmpty(currentProvider)) {
        let apiParams = getCommonPoviderDetails();
        const respProviderList: any =
          await OnCallLookUpInputService.updateCommonProviderDetails(apiParams);
        if (respProviderList.isSuccess) {
          AddProviderContextData.updateProviderList(respProviderList.result);
        } else {
          Toast.error(respProviderList.message);
        }
      } // if provider is already present in card
      else {
        if (selectedDoctorDetails[0].guid !== currentProvider["guid"]) {
          let apiParams = getCommonPoviderDetails();
          const respProviderList: any =
            await OnCallLookUpInputService.updateCommonProviderDetails(
              apiParams
            );
          if (respProviderList.isSuccess) {
            AddProviderContextData.updateProviderList(respProviderList.result);
          } else {
            Toast.error(respProviderList.message);
          }
        } else {
          Toast.error(CONSTANTS.MESSAGES.PROVIDER_SCHEDULE_ALREADY_PRESENT);
        }
      }
    } else {
      Toast.error(t("notOnCallError"));
    }
  };

  const checkIfLargeScreen = () => {
    if (utilService.getScreenSize() === "large") {
      setIsLargeScreen(true);
    } else {
      setIsLargeScreen(false);
    }
  };

  return (
    <>
      <div>
        {AddProviderContextData.fromComponent !==
          CONSTANTS.COMPONENTS.STATUS_BOARD && (
          <div className="button-container">
            {screenType === "small" ? (
              <div
                color="medium"
                className="cancel-btn btn-curved custom-back-button-container"
                onClick={() => props.backBtnClicked(true)}
              >
                <IonIcon
                  className="back-button-onCallLookUp"
                  icon={chevronBackOutline}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
      <div className="ocl-search-result-container-div">
        <div
          className={classNames({
            "ocl-text-title": true,
            "ocl-text-title-provider-cont": AddProviderContextData.fromComponent
              ? true
              : false,
          })}
        >
          <span>{t("searchResult", "Search Result")}</span>
        </div>

        {isShowResult && (
          <div
            className={classNames({
              "content-container": true,
              "content-container-large-screen": isLargeScreen,
              "sb-no-border": AddProviderContextData.fromComponent
                ? true
                : false,
            })}
          >
           {props?.userSelectedData?.OptionSelected !== "individual_provider" &&  
           <div className=" tab-container">
              <IonButton
                className={classNames({
                  open: true,
                  "tab-active": activeResultTab === "oncall",
                })}
                onClick={() => setActiveResultTab("oncall")}
                id="open"
              >
                {t("onCall", "On Call")}
              </IonButton>
              <IonButton
                className={classNames({
                  closed: true,
                  "tab-active": activeResultTab === "notoncall",
                })}
                id="closed"
                onClick={() => setActiveResultTab("notoncall")}
              >
                {t("availableNotOnCall", "Available (Not On-Call)")}
              </IonButton>
            </div>}
            <DoctorList
              apiParams={params}
              doctorListInputData={doctorListInput}
              permissions={rolePermissions}
              getSelectedCard={getSelectedCard}
              getSelectedCardAndSchedule={() => {}}
              getIsAllSelectedStatus={() => {}}
              getAllCards={() => {}}
              getAllCardsAndSchedule={() => {}}
              isFullScreen={false}
              isFromCaseHistoryDetails={false}
              patientID={props.pId}
              isFromOnCallSearch={true}
              optionSelected={props.userSelectedData.OptionSelected}
              activeTab={activeResultTab}
            ></DoctorList>
          </div>
        )}

        {AddProviderContextData.fromComponent ===
          CONSTANTS.COMPONENTS.STATUS_BOARD && (
          <div className="button-container">
            {screenType === "small" ? (
              <IonButton
                color="medium"
                className="cancel-btn btn-curved"
                onClick={() => props.backBtnClicked(true)}
              >
                {t("prev", "Prev")}
              </IonButton>
            ) : (
              ""
            )}
            <IonButton
              disabled={selectedDoctorDetails.length ? false : true}
              className="submit-btn button primary-btn sb-add-button btn-curved"
              onClick={() => addProviderDetails()}
            >
              {t("add", "Add")}
            </IonButton>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(OnCallSearchResult);
